import { render, staticRenderFns } from "./document_template_type.vue?vue&type=template&id=43ba4f9f"
import script from "./document_template_type.vue?vue&type=script&lang=js"
export * from "./document_template_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports